import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// /open/payouts and /open/refer — the talent emails' website-only doors to
// Connect Bank and Refer & Earn. They are deliberately NOT in
// public/.well-known/apple-app-site-association: on an iPhone the link stays in
// Safari instead of opening the app, because the 1.5.1 app opens on Requests
// for ?payouts=1 / ?refer=1 without the screen they ask for (and has no MassPay
// screens); the website has both. Once 1.5.2 is in the stores the server sends
// /requests?… instead (JOURNEY_APP_LINKS_READY), and these just keep working.
//
// They only forward, in place (no history entry), to /requests?<flag>=1 with
// the link's other params (utm_…) kept. From there the usual path takes over:
// RequireAuth sends a signed-out visitor through /login?next=, and
// EmailLinkSheets opens Connect Bank or Refer & Earn when it applies.
// The path is fixed and the params are re-encoded, so nothing in the link can
// point it anywhere but /requests (same shape as LegacySuccessRedirect).
export type OpenLinkFlag = "payouts" | "refer";

const OpenLinkRedirect: React.FC<{ flag: OpenLinkFlag }> = ({ flag }) => {
  const params = new URLSearchParams(useLocation().search);
  params.set(flag, "1");
  return <Navigate replace to={`/requests?${params}`} />;
};

export default OpenLinkRedirect;
